import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ingred-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { addIngred, updateIngred } from "@/service/modules/scan";
const __default__ = {
  name: "IngredDialog"
};
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: "addSubset"
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const formRef = ref();
    const subBtnLoading = ref(false);
    const form = reactive({
      name: "",
      introduction: ""
    });
    const id = ref(null);
    const rules = {
      title: [{
        required: true,
        message: "请输入成分名称",
        trigger: "blur"
      }]
    };
    function restForm() {
      id.value = null;
      form.name = "";
      form.introduction = "";
    }
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning("正在保存，请稍后~~");
      restForm();
      emit("closeDialog");
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      try {
        if (props.dialogType === "add") {
          let query = JSON.parse(JSON.stringify(form));
          await addIngred(query);
          ElMessage.success("添加成功");
          emit("restData");
        } else if (props.dialogType === "edit") {
          let query = JSON.parse(JSON.stringify(form));
          query.id = id.value;
          await updateIngred(query);
          ElMessage.success("修改成功");
        }
        subBtnLoading.value = false;
        closeDialog();
        emit("restData");
      } catch {
        subBtnLoading.value = false;
      }
    }
    const title = computed(() => {
      if (props.dialogType === "add") {
        return "添加名称";
      } else if (props.dialogType === "edit") {
        return "编辑名称";
      }
    });
    watch(() => props.dialogVisible, newV => {
      console.log("newV", newV, props);
      if (newV && props.dialogType === "edit") {
        id.value = props.itemData.id;
        form.name = props.itemData.name;
        form.introduction = props.itemData.introduction;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("确定")])),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "成分名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              placeholder: "成分名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "简介",
            prop: "introduction"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.introduction,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.introduction = $event),
              placeholder: "简介",
              type: "textarea",
              rows: 4
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});